import { createQueryHook } from '~/shared/providers/api/createQueryHook';

export type Hauler = {
  id: string;
  name: string;
};

export const useHaulersQuery = createQueryHook(
  'transportation.haulers',
  (_params: { searchTerm: string }) => ({
    haulers: {
      id: true,
      name: true,
    },
  }),
);
